import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import { LANGUAGES as LANGS } from '../../i18n/languages';

import { ta } from '../../i18n/adminT';
export default function ContactsSettings() {
  const [privacyDocs, setPrivacyDocs] = useState({}); // chiave "lang" -> record
  const [uploadingPrivacy, setUploadingPrivacy] = useState(null); // lang in corso di caricamento
  const [actionError, setActionError] = useState('');

  const loadPrivacyDocs = async () => {
    try {
      const res = await api.getDocuments();
      const map = {};
      res.data.filter((d) => d.doc_type === 'event_privacy').forEach((d) => { map[d.lang] = d; });
      setPrivacyDocs(map);
    } catch {
      // in caso di errore l'elenco resta vuoto
    }
  };

  useEffect(() => { loadPrivacyDocs(); }, []);

  const handleUploadPrivacy = async (lang, file) => {
    if (!file) return;
    setActionError('');
    setUploadingPrivacy(lang);
    try {
      await api.uploadDocument('event_privacy', lang, file);
      await loadPrivacyDocs();
    } catch (err) {
      setActionError(err.message);
    } finally {
      setUploadingPrivacy(null);
    }
  };

  return (
    <div>
      <h1 className="admin-page-title">{ta('Impostazioni contatti')}</h1>
      <p className="admin-page-subtitle">
        {ta('Configurazione della pagina')} <span className="mono">{ta('/contatti')}</span>{ta('. Il nome dell\'evento attivo e la data di fine si impostano invece direttamente nella pagina "Contatti" del menu principale, insieme all\'elenco dei contatti raccolti.')}
      </p>

      {actionError && <div className="form-error">{actionError}</div>}

      <div className="admin-card" style={{ maxWidth: 680 }}>
        <h3 style={{ marginBottom: 10 }}>{ta('Informativa privacy dedicata')}</h3>
        <p style={{ fontSize: '0.85rem', color: 'var(--muted-text)', marginBottom: 14 }}>
          {ta('Facoltativa: se non carichi nulla qui, la pagina')} <span className="mono">{ta('/contatti')}</span> {ta('usa automaticamente l\'informativa privacy già caricata per il controllo ingressi (Impostazioni → Documenti privacy e sicurezza).')}
        </p>
        <div className="field-row" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
          {LANGS.map(({ key: lang, label: langLabel, flag }) => {
            const doc = privacyDocs[lang];
            return (
              <div key={lang} style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{ fontSize: '0.85rem', color: 'var(--muted-text)' }}>
                  {flag} {langLabel}
                  <br />
                  {doc ? `${ta('Caricato:')} ${doc.original_name}` : ta('Usa quella del controllo ingressi')}
                </div>
                <div className="upload-drop" style={{ padding: '10px 18px' }}>
                  <label htmlFor={`upload-event-privacy-${lang}`}>
                    {uploadingPrivacy === lang ? ta('Caricamento…') : doc ? ta('Sostituisci PDF') : ta('Carica PDF')}
                  </label>
                  <input
                    id={`upload-event-privacy-${lang}`}
                    type="file"
                    accept="application/pdf"
                    onChange={(e) => handleUploadPrivacy(lang, e.target.files[0])}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
